export const GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID = "/HostedPaymentPage/GetHostedPage"//GetPaymentPageTransactionByUniqueId" 
export const HOSTED_PAGE_DO_PAYMENT = "/HostedPayment/HostedPageDoPayment" 
export const CHECK_BIN_CARD_NUMBER = "/HostedPayment/ProcessCheckBin" 